import { INSERT_UPDATE_DELEGATE_SEMINAR_ACTION_TYPE, GET_DELEGATE_SEMINAR_ACTION_TYPE } from "../../../utils/constants";


const initialState = [];

function delegate_SeminarReducer(state = initialState, action) {
    const { type, payload } = action

    switch (type) {
        case INSERT_UPDATE_DELEGATE_SEMINAR_ACTION_TYPE:
            return [...state, payload];
        case GET_DELEGATE_SEMINAR_ACTION_TYPE:
            return [...state, payload];

        default:
            return state;
    }
};

export default delegate_SeminarReducer